<template>
    <div class="inner-container">
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :isGkkpPaid="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadRepPaid="downloadRepPaid"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
                :hasDeltaRep="true"
                @downloadDeltaRep="downloadDeltaRep"
            ></forms-download-reprt>
        </div>
     <div class="filter-container">
         <div class="left-content">
         </div>
         <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadDatas"
                />
             <div class="filter-actions filter-actions-flex">
                    <c-budget-forms-copy-data
                        v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                        :budgetForm="isPaidTab ?  budgetFormPaid : budgetForm"
                        :header="header"
                        :isLoad="isLoad"
                        :isPaidTab="isPaidTab"
                        @keyPress="keyPress"
                    />
                    <b-button :style="{ 'minWidth': '110px' }" variant="primary" @click="onEnterCategoryName" v-if="variantAttribute" :disabled="isLoad || !isCurTabDataValid"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</b-button>
                    <b-button :style="{ 'minWidth': '110px' }" variant="success" @click="prepareForSave" :disabled="isLoad || !variantAttribute || !hasChangedFields">{{ getCommonText('save') }}</b-button>
                </div>
            </div>
        </div>

        <b-tabs 
            active-nav-item-class="budget-form_tabs_active_tab"
            nav-class="budget-form_tabs" 
            v-model="activeTabIndex"
        >

            <b-tab 
                :title="getCommonText('budget_expense')"
                @click="updateRoute(0)" 
            >
                <!-- Первая вкладка -->
                <form-418-tab1  
                    ref="formTab"
                    :budgetForm="budgetForm"
                    :getFormText="getFormText"
                    :tableFields="tableFields"
                    :getCommonText="getCommonText"
                    :getDecText="getDecText"
                    :getUnitLockName="getUnitLockName"
                    :isFieldValid="isFieldValid"
                    :lng="lng"
                    :variantAttribute="variantAttribute"
                    :nameIsEmpty="nameIsEmpty"
                    :listUnit="listUnit"
                    :total="total"
                    :isLoad="isLoad"
                    :selectAll="selectAll"
                    :areAllRequiredFieldsValid="areAllRequiredFieldsValid"
                    @setIsAllDelete="setIsAllDelete"
                    @setSelectAll="setSelectAll"
                    @deleteItemWithAttachedFiles="deleteItemWithAttachedFiles"
                    @onEditCatName="onEditCatName"
                    @keyup13="keyup13"
                    @keyPress="keyPress"
                    @inputFixed="inputFixed"
                    @onFilesClick="onFilesClick"
                    @onAddNewCat="onEnterCategoryName"
                    @selectedUnitChanged="selectedUnitChanged"
                    @markAsChanged="markAsChanged"
                ></form-418-tab1>
        
                <!-- Первая вкладка -->
                <files-updown v-if="isFilterReady" 
                            :header="header"
                            :variant-attribute="variantAttribute"
                            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                            :load="load"
                            @getFiles="getFiles"
                            @getNewFiles="getNewFiles($event)"
                            @delFile="delFile($event)"
                            @onFilePreview="onFilePreview"
                            ref="fileUpdown"
                ></files-updown>

                <!-- Первая вкладка -->
                <modal-files-management-nodecode
                    ref="modalFilesManagement"
                    :variant-attribute="variantAttribute"
                    @triggDownloadFile="triggDownloadFile"
                    @triggDownloadAllFiles="triggDownloadAllFiles"
                    @fileUpload="fileUpload"
                    @toggleIsAdd="toggleIsAdd($event)"
                />

                <!-- Первая вкладка -->
                <c-set-b-f-category-name
                    ref="setCatNameModal"
                    :budgetForm="budgetForm"
                    :categoryFieldNames="categoryFieldNames"
                    :lng="lng"
                    :maxNameLengthSymbls="500"
                    :getCommonText="getCommonText"
                    @addItem="addItem"
                    @saveItem="onNameChanged"
                />
            </b-tab>
            <b-tab 
                :title="getCommonText('paid_services')" 
                @click="updateRoute(1)"
            >
                <!-- Вторая вкладка -->
                <form-418-tab1  
                    ref="formTabPaid"
                    :budgetForm="budgetFormPaid"
                    :getFormText="getFormText"
                    :tableFields="tableFields"
                    :getCommonText="getCommonText"
                    :getDecText="getDecText"
                    :getUnitLockName="getUnitLockName"
                    :isFieldValid="isFieldValid"
                    :lng="lng"
                    :variantAttribute="variantAttribute"
                    :nameIsEmpty="nameIsEmpty"
                    :listUnit="listUnit"
                    :total="totalPaid"
                    :isLoad="isLoad"
                    :selectAll="selectAllPaid"
                    :areAllRequiredFieldsValid="areAllRequiredFieldsValidPaid"
                    @setIsAllDelete="setIsAllDeletePaid"
                    @setSelectAll="setSelectAll"
                    @deleteItemWithAttachedFiles="deleteItemWithAttachedFilesPaid"
                    @onEditCatName="onEditCatNamePaid"
                    @keyup13="keyup13"
                    @keyPress="keyPress"
                    @inputFixed="inputFixed"
                    @onFilesClick="onFilesClickPaid"
                    @onAddNewCat="onEnterCategoryName"
                    @selectedUnitChanged="selectedUnitChanged"
                    @markAsChanged="markAsChanged"
                ></form-418-tab1>

                <!-- Вторая вкладка -->
                <files-updown v-if="isFilterReady" :header="header"
                            :variant-attribute="variantAttribute"
                            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                            :load="load"
                            :isPaidTab="true"
                            @getFiles="getFilesPaid"
                            @getNewFiles="getNewFilesPaid($event)"
                            @delFile="delFilePaid($event)"
                            @onFilePreview="onFilePreview"
                            ref="fileUpdownPaid"
                ></files-updown>

                <!-- Вторая вкладка -->
                <modal-files-management-nodecode
                    ref="modalFilesManagementPaid"
                    :variant-attribute="variantAttribute"
                    @triggDownloadFile="triggDownloadFilePaid"
                    @triggDownloadAllFiles="triggDownloadAllFilesPaid"
                    @fileUpload="fileUploadPaid"
                    @toggleIsAdd="toggleIsAddPaid($event)"
                />

                <!-- Вторая вкладка -->
                <c-set-b-f-category-name
                    ref="setCatNameModalPaid"
                    :budgetForm="budgetFormPaid"
                    :categoryFieldNames="categoryFieldNames"
                    :lng="lng"
                    :maxNameLengthSymbls="500"
                    :getCommonText="getCommonText"
                    @addItem="addItem"
                    @saveItem="onNameChanged"
                />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import ModalFilesManagementNodecode from '@/modules/budget-request/components/modal-files-management-nodecode.vue';
import FormsHandlerMixin1Paid from "../mixins/forms-handler-mixin-1-paid";
import CBudgetFormsCopyData from '../components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "../components/forms-download-reprt.vue";
import CSetBFCategoryName from "../components/c-set-bf-category-name.vue";
import Form418Tab1 from './Form418_v2_tab1.vue';
import CBudgetFormsDataTransfer from '../components/budget-forms-data-transfer.vue';

export default {
    name: 'Form418_v2',
    components: { 
        FilesUpdown, 
        BudgetFormsList, 
        FormsDownloadReprt, 
        ModalFilesManagementNodecode, 
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        Form418Tab1,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin1Paid],
    data() {
        return {
            form: {
                code: '418',
                name_ru: 'Форма 418 версия 2',
                name_kk: 'Форма 418 нұсқасы 2',
                spf: {
                    name: '418-Форма 418',
                    spf: '418'
                }
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            budgetFormPaid: [],
            header: null,
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            row_files: [],
            isAdd: false,
            rowId: null,
            rowIdPaid: null,
            newRowStartId: -1,
            categoryFieldNames: {ru: "name_ru", kk: "name_kk"},
            selectAll: false,
            selectAllPaid: false,
        };
    },
    async mounted() {
        await this.loadUnits();
    },
    created() {
        this.$emit("setForm", this.form);
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },

        progress() {
            this.$emit("setProgress", this.progress);
        },

        selectAllPaid() {
            this.$refs.formTabPaid.setSelectAll(this.selectAllPaid);
        },

        selectAll() {
            this.$refs.formTab.setSelectAll(this.selectAll);
        }
    },

    methods: {
        isFieldValid(value) {
            return value !== null && value !== '' && value > 0;
        },

        markAsChanged(item) {
            if (item.id > 0) {
                item.isChanged = true;
            }
        },

        onNameChanged(item) {
            this.markAsChanged(item);
        },

        addItem(nameRu, nameKk) {
            const item = { 
                id: this.newRowStartId,
                name_ru: nameRu,
                name_kk: nameKk,
                isChanged: true
            };
            this.newRowStartId--;
            this.itemUpdate(item);
            this.defineTotalProperty(item);
            if (this.activeTabIndex === 0) this.budgetForm.push(item);
            if (this.activeTabIndex === 1) this.budgetFormPaid.push(item);
        },

        async itemUpdate(item) {
            this.$set(item, 'unit', null);
            this.$set(item, 'unit_inf', null);
            this.$set(item, 'amount', 0);
            this.$set(item, 'cost', 0);
            this.$set(item, 'files', 0);
            this.$set(item, 'itemToDelete', false);

            try {
                this.load = true;
                const url = this.activeTabIndex === 0 ? '/api-py/get-new-row-files-form' : '/api-py/get-new-row-files-form-paid';
                const response = await fetch(`${url}/${item.id}/${JSON.stringify(this.header)}`);
                const emptyRowFiles = await response.json();
                this.$set(item, 'row_files', emptyRowFiles);
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} itemUpdate`, error.toString());
            }
            this.load = false;
        },

        number(value) {
            return (isNaN(parseFloat(value)) ? 0 : parseFloat(value));
        },

        getFiles(data) {
            this.files = data;
        },
        getFilesPaid(data) {
            this.filesPaid = data;
        },

        loadDatas() {
            this.budgetForm.splice(0);
            const url = '/api-py/get-budget-request-form-with-row-attach-files/';
            this.getData(this.budgetForm, url);
        },

        loadDatasPaid() {
            this.budgetFormPaid.splice(0);
            if (!this.isGkkpMode) return;
            const url = '/api-py/get-budget-request-form-with-row-attach-files-paid/';
            this.getData(this.budgetFormPaid, url);
        },

        async getData(budgetForm, url) {
            this.load = true;

            this.$set(this.header, 'form_version', this.form.code + '_v2')
            try {
                const response = await fetch(url + JSON.stringify(this.header));
                const values = await response.json();
                
                values.forEach(val => {
                    const item = this.setItemParams(val);
                    this.defineTotalProperty(item);
                    budgetForm.push(item);
                });
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas`, error.toString());
            }
            this.load = false;
        },

        setItemParams(val) {
            return {
                        id: val.id,
                        name_ru: val.name_ru,
                        name_kk: val.name_kk,
                        unit: val.unit,
                        unit_inf: this.getItem(val.unit, this.listUnit),
                        amount: val.amount,
                        cost: val.cost,
                        files: val.files,
                        row_files: val.row_files,
                        itemToDelete: false,
                        isChanged: false
                    }
        },

        defineTotalProperty(item) {
            Object.defineProperty(item, 'total', {
                get: () => {
                    const amount = this.safeDecimal(item.amount);
                    const cost = this.safeDecimal(item.cost);
                    const totalRounded = amount.mul(cost).toDecimalPlaces(3).toNumber();
                    return totalRounded;
                }
            });
        },

        toggleIsAdd(return_object) {
            const curBudgetForm = this.budgetForm.find(b => b.id === this.rowId)
            curBudgetForm['row_files'] = return_object['row_files']
            curBudgetForm['files'] = return_object['num_attach_files']
            this.rowId = null;
            this.markAsChanged(curBudgetForm);
        },

        toggleIsAddPaid(return_object) {
            const curBudgetForm = this.budgetFormPaid.find(b => b.id === this.rowIdPaid)
            curBudgetForm['row_files'] = return_object['row_files']
            curBudgetForm['files'] = return_object['num_attach_files']
            this.rowIdPaid = null;
            this.markAsChanged(curBudgetForm);
        },

        prepareForSave() {
            const values = [];
            let budgetForm = [];
            if (this.activeTabIndex === 1) budgetForm = this.budgetFormPaid
            else budgetForm = this.budgetForm;
            for (const row of budgetForm) {
                if (this.isSavingForbidden(row, this.tableFields, ['amount', 'cost'], ['unit'])) return;
                if (!row.isChanged) continue;
                const item = Object.assign({}, this.header);
                this.$set(item, 'id', row.id);
                this.$set(item, 'name_ru', row.name_ru);
                this.$set(item, 'name_kk', row.name_kk);
                if (row.unit_inf) {
                    this.$set(item, 'unit', row.unit_inf.code);
                }
                else {
                    this.$set(item, 'unit', null);
                }
                this.$set(item, 'amount', parseFloat(row.amount));
                this.$set(item, 'cost', parseFloat(row.cost));
                this.$set(item, 'row_files', row.row_files);

                values.push(item);
            }
            if (values.length > 0) {
                this.$bvModal.msgBoxConfirm(
                    this.getCommonText('on_save'),
                    {
                        title: this.getCommonText('confirm'),
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: this.getCommonText('yes'),
                        cancelTitle: this.getCommonText('cancel'),
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                        if (value && this.variantAttribute) {
                            if (this.activeTabIndex === 0) {
                                this.save(values);
                            } else { 
                                this.savePaid(values);
                            }
                        }
                    })
                    .catch(error => {
                        this.makeToast('danger', this.getErrText('saving_error'), error.toString());
                    });
            }
        },

        save(values) {
            this.saveData(values, this.loadDatas);
        },

        savePaid(values) {
            const isPaid = true;
            this.saveData(values, this.loadDatasPaid, isPaid);
        },

        async saveData(values, loadDatas, isPaid = false) {
            this.isLoad = true;
            try {
                const data = {
                    values: values,
                    header: {...this.header, isGkkpPaid: isPaid},
                };

                const response = await fetch("/api-py/save-brform418_v2/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    loadDatas();
                    
                    if (this.files.length === 0) {
                        this.makeToast('warning', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                } else {
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        }
    },
    computed: {
        total() {
            let sum = this.safeDecimal(0);
            for (const row of this.budgetForm) {
                const total = this.safeDecimal(row.total);
                sum = sum.add(total);
            }
            return Math.ceil(sum.toNumber());
        },

        totalPaid() {
            let sum = this.safeDecimal(0);
            for (const row of this.budgetFormPaid) {
                const total = this.safeDecimal(row.total);
                sum = sum.add(total);
            }
            return Math.ceil(sum.toNumber());
        },

        areAllRequiredFieldsValid() {
            return this.budgetForm.every(item => 
                this.isFieldValid(item.amount) && this.isFieldValid(item.cost) && item.unit
            );
        },

        areAllRequiredFieldsValidPaid() {
            return this.budgetFormPaid.every(item => 
                this.isFieldValid(item.amount) && this.isFieldValid(item.cost) && item.unit
            );
        },

        isCurTabDataValid() {
            if (this.activeTabIndex === 0) return this.areAllRequiredFieldsValid
            else return this.areAllRequiredFieldsValidPaid;
        },

        getFormText() {
            return this.setFormText('forms_v2_common.');
        },

        hasChangedFields() {
            let isChanged = false;
            if (this.activeTabIndex === 0) {
                isChanged = this.budgetForm.some(itm => itm.isChanged);
            } else {
                isChanged = this.budgetFormPaid.some(itm => itm.isChanged);
            }

            return isChanged;
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'name',
                        label: this.getCommonText('name')
                    },
                    {
                        key: 'unit',
                        label: this.getUnitsText('measure')
                    },
                    {
                        key: 'amount',
                        label: this.getFormText('amount')
                    },
                    {
                        key: 'cost',
                        label: this.getFormText('unit_cost')
                    },
                    {
                        key: 'total',
                        label: this.getFormText('total_cost')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        },
    }
};
</script>

<style scoped>
    .filter-actions-flex {
        display: flex;
    }
    .budget-form_tabs {
        display: none;
    }
</style>